export const LABELS_LOAD_MERGE = 'LABELS_LOAD_MERGE';
export const LABELS_LOAD_REPLACE = 'LABELS_LOAD_REPLACE';
export const LABELS_SET_FULL_FETCH_TIMESTAMP = 'LABELS_SET_FULL_FETCH_TIMESTAMP';
export const LABEL_CREATE = 'LABEL_CREATE';
export const LABEL_RECREATE = 'LABEL_RECREATE';
export const LABEL_UPDATE = 'LABEL_UPDATE';
export const LABEL_DELETE = 'LABEL_DELETE';
export const LABEL_SELECT = 'LABEL_SELECT';
export const LABEL_RENAME_START = 'LABEL_RENAME_START';
export const LABEL_RENAME_FINISH = 'LABEL_RENAME_FINISH';
export const LABELS_MARK_STALE = 'LABELS_MARK_STALE';

export const LABEL_ID_PREFIX = 'lbl_';
export const LABEL_NAME_MAX_LENGTH = 30;
